import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ApiCopilotFeedback } from '../apis/core-basic-api-service.interface';

export const PatsnapCopilotFeedBackService = Symbol('PatsnapCopilotFeedBackService');

export interface PatsnapCopilotFeedBackService {
    send(data: { type: 'LIKE' | 'DISLIKE'; query: string; intent: string; product: string; }): Promise<void>;
}

@injectable()
export class PatsnapCopilotFeedBackServiceImpl implements PatsnapCopilotFeedBackService {
    constructor(
        @inject(ApiCopilotFeedback)
        private readonly _apiCopilotFeedback: ApiCopilotFeedback,
    ) {}

    send(data: { type: 'LIKE' | 'DISLIKE'; query: string; content: string; intent: string; product: string; }): Promise<void> {
        return this._apiCopilotFeedback.copilotFeedback(data).then((res) => {});
    }
}
